import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Love, useToast } from 'chemistry'
import { getLocale, getPrefix } from 'common/utils'
import { toggleWishlist } from './toggleWishlist'

export const getWishlistIconTitle = inWishlist => (inWishlist ? 'remove' : 'add')
export const WishlistIcon = ({ inWishlist }) => (
  <Love
    width='20px'
    height='20px'
    pointerEvents='none'
    {...(inWishlist ? { color: 'red.500', filled: true } : { color: 'grey.900' })}
  />
)

export const ADDED_TO_WISHLIST_NOT_LOGGED_IN_LOCAL_STORAGE_KEY = 'productIdAddedToWishlistNotLoggedInFromPDP'
const addProductToWishlistToLocalStorage = productId =>
  localStorage.setItem(ADDED_TO_WISHLIST_NOT_LOGGED_IN_LOCAL_STORAGE_KEY, productId)
export const getProductToWishlistFromLocalStorage = () =>
  localStorage.getItem(ADDED_TO_WISHLIST_NOT_LOGGED_IN_LOCAL_STORAGE_KEY) || ''
const removeProductToWishlistFromLocalStorage = () =>
  localStorage.removeItem(ADDED_TO_WISHLIST_NOT_LOGGED_IN_LOCAL_STORAGE_KEY)

export const AddToWishlistButton = ({ productDetails, currentLocation, productId, isGuest, format, lang, t }) => {
  const { addedToWishlist } = productDetails
  const [inWishlist, setInWishlist] = useState(addedToWishlist)
  const { toast } = useToast()
  const toggle = useMemo(
    () => toggleWishlist({ productDetails, productId, setInWishlist, t, toast }),
    [productDetails, productId, setInWishlist, t, toast]
  )
  const isAlreadyAddedToWishlist = useRef(false)
  const wishListIconTitle = getWishlistIconTitle(inWishlist)
  const locale = getLocale(format, lang)
  const prefix = getPrefix(locale)

  useEffect(() => {
    if (isGuest || addedToWishlist || isAlreadyAddedToWishlist.current) return
    const productAddedToWishlistNotLoggedIn = getProductToWishlistFromLocalStorage()
    if (parseInt(productAddedToWishlistNotLoggedIn) !== parseInt(productId)) return
    toggle(inWishlist)
    isAlreadyAddedToWishlist.current = true
    removeProductToWishlistFromLocalStorage()
  }, [isGuest, inWishlist, productDetails, addedToWishlist, toggle, productId])

  const onClick = () => {
    if (isGuest) {
      addProductToWishlistToLocalStorage(productId)
      window.location.assign(`${prefix}/login?redirectUrl=${encodeURIComponent(currentLocation)}`)
      return
    }
    toggle(inWishlist)
    document.activeElement.blur()
  }
  return (
    <Button
      id='add-item-to-wishlist'
      variant='secondary'
      onClick={onClick}
      title={t(`wishlist.${wishListIconTitle}`)}
      sx={{
        position: 'absolute',
        display: 'inline-flex',
        alignItems: 'center',
        paddingX: '0',
        paddingY: '0',
        top: '12px',
        right: '12px',
        zIndex: 3,
        width: '48px',
        height: '48px',
        backgroundColor: '#FFFFFF',
        border: '1px solid',
        borderColor: 'grey.900',
        borderRadius: '8px'
      }}
    >
      <WishlistIcon inWishlist={inWishlist} />
    </Button>
  )
}
